export enum AccountType {
  InheritFromParent = 'Inherit from Parent',
  LocalAccount = 'Local',
  NationalAccount = 'National',
}
